import React from 'react';
import PropTypes from 'prop-types';
import './CompanyList.scss';

const CompanyList = () => (
  <div className="CompanyList">
    CompanyList Component
  </div>
);

CompanyList.propTypes = {};

CompanyList.defaultProps = {};

export default CompanyList;
